import { Injectable } from '@angular/core';
import { GoGreenStatusResponse } from '@api';
import { ComponentStore } from '@ngrx/component-store';
import { Intention } from '../models/intention';
import { VerificationStatus } from '../models/verificaion-status';

export interface GoGreenState {
  info: GoGreenStatusResponse | null;
  done: boolean;
  intention: Intention;
  verificationStatus: VerificationStatus;
}

const defaultState: GoGreenState = {
  info: null,
  done: false,
  intention: undefined,
  verificationStatus: 'input',
};

@Injectable()
export class GoGreenStore extends ComponentStore<GoGreenState> {
  constructor() {
    super(defaultState);
  }

  readonly store$ = this.select((state) => state);

  readonly loadInfo = this.updater((state, info: GoGreenStatusResponse) => ({
    ...state,
    info,
  }));

  readonly setVerificationResult = this.updater((state, payload: { email_address: string; email_validated: boolean }): GoGreenState => {
    return {
      ...state,
      info: state.info
        ? {
            ...state.info,
            email_address: payload.email_address,
            email_validated: payload.email_validated,
          }
        : null,
      verificationStatus: payload.email_validated ? 'changed' : 'input',
    };
  });

  readonly setOptedIn = this.updater((state) => ({
    ...state,
    done: true,
  }));

  readonly setVerificationWaiting = this.updater((state) => ({
    ...state,
    verificationStatus: 'waiting',
  }));

  readonly setVerificationCanceled = this.updater((state) => ({
    ...state,
    verificationStatus: 'input',
  }));

  readonly setVerificationSuccess = this.updater((state) => ({
    ...state,
    verificationStatus: 'changed',
  }));

  readonly setIntention = this.updater((state, submitCorrectDetails: boolean) => {
    let intention: Intention = undefined;

    if (state.info?.email_validated && !submitCorrectDetails) {
      intention = 'alreadyVerifiedAndNoChange';
    } else if (!state.info?.email_validated && !submitCorrectDetails) {
      intention = 'needsVerification';
    } else if (submitCorrectDetails) {
      intention = 'withCorrectedDetails';
    }

    return {
      ...state,
      intention,
    };
  });
}
